import EbookLandingPageLayout from 'layouts/EbookLandingPageLayout';
import ebookData from 'utils/ebooks.json';

export const getStaticPaths = () => {
  const paths = ebookData.map((ebook) => ({
    params: { slug: ebook.id },
  }));
  return { paths, fallback: false };
};

export const getStaticProps = ({ params }) => {
  const ebook = ebookData.find((ebook) => ebook.id === params.slug);
  return { props: { ebook } };
};

export default function EbookLandingPage({ ebook }) {
  return <>{ebook && <EbookLandingPageLayout ebook={ebook} />}</>;
}
